import { Component, Inject, OnInit, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { RootService } from 'src/app/shared/services/root.service';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { WishlistService } from 'src/app/shared/services/wishlist.service';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { CanonicalService } from './../../shared/seo/canonical.service';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-customer-rating',
  templateUrl: './customer-rating.component.html',
  styleUrls: ['./customer-rating.component.scss']
})
export class CustomerRatingComponent implements OnInit {
  sub: Subscription = new Subscription
  productId: any;
  customerRatingForm: any;
  performance: any
  safety: any
  design: any
  comfort: any
  overall: any
  isShowTankyouPage: boolean = false;
  showRatingSideBar: boolean = false;
  productRatingList: any[] = [];
  ratingPresent: boolean = false;
  closeResult: any;
  productReviewData: any;
  @ViewChild("productReview", { read: TemplateRef }) productReview!: TemplateRef<any>;
  productDetailList: any;
  userData: any;
  isShowPopup: any;
  oneStarRatingCount: number;
  twoStarRatingCount: number;
  threeStarRatingCount: number;
  fourStarRatingCount: number;
  fiveStarRatingCount: number;
  totalRating: any;
  sortList = ["Newest First", "Oldest First"]
  totalReviewsCount: any = 0;
  descriptionCount: number;

  environment1 = environment.s3bucket.url;
  heartUrls = {
    empty: "assets/images/Star-unfilled.svg",
    half: "assets/images/Star-unfilled.svg",
    full: "assets/images/Star-filled.svg"
  };
  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private fb: FormBuilder, private rootService: RootService, private router: Router, private modalService: NgbModal
    , private toastrService: ToastrService, private wishlistService: WishlistService,
     private behaviorService: BehaviourSubjectService,private canonicalservice: CanonicalService,@Inject(PLATFORM_ID) private platformId: Object) {
    this.customerRatingForm = this.fb.group({
      titleAndReview: [""],
      writeReview: [""],
    })
  }

  isUserLoggedIn: any;

  ngOnInit(): void {
    this.canonicalservice.createCanonicalURL('');
    this.sub.add(this.behaviorService.isLoggedIn.subscribe(() => {
      this.isUserLoggedIn = this.rootService.isLoggedIn() ? true : false;
      this.userData = this.rootService.getUserData();
    }));
    this.activatedRoute.paramMap.subscribe(params => {
      this.productId = params.get('id')
    })
    this.getVehicleDetail();
    this.getProductRating()
  }

  getVehicleDetail() {
    let data = {
      product_id: this.productId
    }
    this.sub.add(this.apiService.getVehicleDetails(data).subscribe({
      next: (res: any) => {
        this.productDetailList = res?.data
        if (!this.rootService.getUserData()) {
          let wishList: any = []
          wishList = this.wishlistService.getWishlist();
          if (wishList?.length > 0) {
            wishList?.forEach((el: any) => {
              if (el == this.productDetailList.id) {
                this.productDetailList.wishlist = true
              }
            })
          }
        }
      },
      error: () => { },
      complete: () => { }
    }))
  }

  checkForLogin() {
    var myDiv: any
    if (this.rootService.getUserData()) {
      myDiv = document.getElementsByClassName(".sidebar-drawer");
      myDiv.setAttribute("style", "display:block;");
    }
    else
      this.router.navigate(['/login/'])
  }

  writeReview() {
    if (this.ratingPresent) {
      this.updateProductRating()
    }
    else {
      let formData = new FormData
      formData.append("action_type", "product"),
        formData.append("product_id", this.productId),
        formData.append("rating_data", JSON.stringify([{ 'type': 'safety', 'rating': this.safety }, { 'type': 'performance', 'rating': this.performance }, { 'type': 'design', 'rating': this.design }, { 'type': 'comfort', 'rating': this.design }, { 'type': 'overall', 'rating': this.overall }])),
        formData.append("organization_id", ""),
        formData.append("title", this.customerRatingForm.value.titleAndReview),
        formData.append("description", this.customerRatingForm.value.writeReview),
        formData.append("image", ""),
        formData.append("video", "")
      this.sub.add(this.apiService.createReview(formData).subscribe({
        next: () => {
          this.isShowTankyouPage = true
        },
        error: () => { }
      }))
    }
  }

  getProductRating() {
    let data = {
      "product_id": this.productId,
      "action_type": "product",
    }
    this.sub.add(this.apiService.getRatings(data).subscribe({
      next: (res: any) => {
        this.productRatingList = res.data;
        this.totalReviewsCount = res.total_count
        this.safety = 0;
        this.performance = 0;
        this.design = 0;
        this.comfort = 0;
        this.overall = 0;
        var overallCount = 0;
        var safetyCount = 0;
        var performanceCount = 0;
        var designCount = 0;
        var comfortCount = 0;
        this.oneStarRatingCount = 0;
        this.twoStarRatingCount = 0;
        this.threeStarRatingCount = 0;
        this.fourStarRatingCount = 0;
        this.fiveStarRatingCount = 0;
        this.totalRating = 0;
        this.descriptionCount = 0;
        if (this.productRatingList) {
          for (let i = 0; i < this.productRatingList?.length; i++) {
            if (this.productRatingList[i].description) {
              this.descriptionCount += 1;
            }
            for (let j = 0; j < this.productRatingList[i].rating_master?.length; j++) {
              if (this.productRatingList[i].rating_master[j].parameter == "safety") {
                safetyCount += 1;
                this.safety += this.productRatingList[i].rating_master[j].rating
                if (i == this.productRatingList?.length - 1)
                  this.safety = this.safety / safetyCount
              }
              else if (this.productRatingList[i].rating_master[j].parameter == "performance") {
                performanceCount += 1;
                this.performance += this.productRatingList[i].rating_master[j].rating
                if (i == this.productRatingList?.length - 1)
                  this.performance = this.performance / performanceCount
              }
              else if (this.productRatingList[i].rating_master[j].parameter == "design") {
                designCount += 1;
                this.design += this.productRatingList[i].rating_master[j].rating
                if (i == this.productRatingList?.length - 1)
                  this.design = this.design / designCount
              }
              else if (this.productRatingList[i].rating_master[j].parameter == "comfort") {
                comfortCount += 1;
                this.comfort += this.productRatingList[i].rating_master[j].rating
                if (i == this.productRatingList?.length - 1)
                  this.comfort = this.comfort / comfortCount
              }
              else if (this.productRatingList[i].rating_master[j].parameter == "overall") {
                overallCount += 1;
                this.overall += this.productRatingList[i].rating_master[j].rating
                if (this.productRatingList[i].rating_master[j].rating == 1) {
                  this.oneStarRatingCount += 1;
                }
                else if (this.productRatingList[i].rating_master[j].rating == 2) {
                  this.twoStarRatingCount += 1;
                }
                else if (this.productRatingList[i].rating_master[j].rating == 3) {
                  this.threeStarRatingCount += 1;
                }
                else if (this.productRatingList[i].rating_master[j].rating == 4) {
                  this.fourStarRatingCount += 1;
                }
                else if (this.productRatingList[i].rating_master[j].rating == 5) {
                  this.fiveStarRatingCount += 1;
                }
                if (i == this.productRatingList?.length - 1)
                  this.overall = this.overall / overallCount
              }
            }
            if (this.oneStarRatingCount > 0 || this.twoStarRatingCount > 0 || this.threeStarRatingCount > 0 || this.fourStarRatingCount > 0 || this.fiveStarRatingCount) {
              this.totalRating = this.overall.toFixed(1)
            } else {
              this.totalRating = 0;
            }
          }
        }
      }
    }))
  }
  clickToClose() {
    this.showRatingSideBar = true
  }
  clickToOpen() {
    this.showRatingSideBar = false
    this.isShowTankyouPage = false
    this.getUserWiseProductRating()
  }
  getUserWiseProductRating() {
    if (this.rootService.getUserData()) {

      let data = {
        "product_id": this.productId,
        "action_type": "product",
        "is_customer_rating": true
      }
      this.sub.add(this.apiService.getRatings(data).subscribe({
        next: (res: any) => {
          if (res.data?.length > 0) {

            this.ratingPresent = true
            let rating = res.data[0].rating_master
            rating.forEach((e: any) => {
              if (e.parameter == "safety") {
                this.safety = e.rating
              }
              if (e.parameter == "performance") {
                this.performance = e.rating
              }
              if (e.parameter == "design") {
                this.design = e.rating
              }
              if (e.parameter == "comfort") {
                this.comfort = e.rating
              }
              if (e.parameter == "overall") {
                this.overall = e.rating
              }
            })
            this.customerRatingForm.controls.writeReview.setValue(res.data[0].description)
            this.customerRatingForm.controls.titleAndReview.setValue(res.data[0].title)
            var json = {
              overall: res.data[0].rating_master.find((e: any) => {
                if (e.parameter == "overall") {
                  return e.rating
                }
              }),
              performance: res.data[0].rating_master.find((e: any) => {
                if (e.parameter == "performance") {
                  return e.rating
                }
              }),
              safety: res.data[0].rating_master.find((e: any) => {
                if (e.parameter == "safety") {
                  return e.rating
                }
              }),
              comfort: res.data[0].rating_master.find((e: any) => {
                if (e.parameter == "comfort") {
                  return e.rating
                }
              }),
              design: res.data[0].rating_master.find((e: any) => {
                if (e.parameter == "design") {
                  return e.rating
                }
              }),
              ratingPresent: true,
              productId: this.productId,
              title: res.data[0].title,
              description: res.data[0].description,
              image: res.data[0].image[0],
              model: this.productDetailList.model,
              mainImage: this.productDetailList.images[0].image_url
            }
            this.productReviewData = json;

            this.openPopup();
          }
          else {
            var json1 = {
              overall: 1,
              performance: 1,
              safety: 1,
              comfort: 1,
              design: 1,
              ratingPresent: false,
              productId: this.productId,
              title: '',
              description: '',
              image: '',
              model: this.productDetailList.model,
              mainImage: this.productDetailList.images[0].image_url
            }
            this.productReviewData = json1;
            this.openPopup();
          }
        }
      }))
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', this.router.url)
      this.router.navigate(['/login/'])
      }
    }

  }

  updateProductRating() {
    let formData = new FormData
    formData.append("action_type", "product");
    formData.append("product_id", this.productId);
    formData.append("rating_data", JSON.stringify([{ 'type': 'safety', 'rating': this.safety }, { 'type': 'performance', 'rating': this.performance }, { 'type': 'design', 'rating': this.design }, { 'type': 'comfort', 'rating': this.design }, { 'type': 'overall', 'rating': this.overall }]));
    formData.append("title", this.customerRatingForm.value.titleAndReview);
    formData.append("description", this.customerRatingForm.value.writeReview);
    formData.append("rating_master_id", this.productRatingList[0].rating_master[0].rating_master);
    this.sub.add(this.apiService.updateReview(formData).subscribe({
      next: () => {
        this.isShowTankyouPage = true
      }
    }))
  }

  openPopup() {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'side-drawer'
    };
    this.modalService.open(this.productReview, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;

    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  bookNow() {
    if (this.isUserLoggedIn) {
      let sublob = this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
      let model = this.productDetailList.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.router.navigate(['/lead-booking/' + sublob + '/' + this.productDetailList.lob_seo + '/' + this.productDetailList.ppl_seo + '/' + model + '/' + this.productDetailList.id]);
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', this.router.url)
      this.router.navigate(['/login/']);
      }
    }
  }
  bookTestDrive() {

    if (this.rootService.getUserData()) {
      this.userData = this.rootService.getUserData()
      if (this.userData === null || undefined || "") {
        this.isShowPopup = true
        return
      }
      let sublob = this.productDetailList.sub_lob.replace(/\s/g, '-')?.toLowerCase();
      let model = this.productDetailList.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.router.navigate(['/book-test-drive/' + sublob + '/' + this.productDetailList.lob_seo + '/' + this.productDetailList.ppl_seo + '/' + model + '/' + this.productDetailList.id]);
    }
    else {
      if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('previousUrl', this.router.url)
      this.router.navigate(['/login/'])
      }
    }

  }

  clickToAddWishlist(event: any) {
    if (this.rootService.getUserData()) {
      for (let e = 0; e < this.productDetailList?.length; e++) {
      }
      if (this.productDetailList.id == event) {
        if (this.productDetailList.wishlist == false) {
          this.productDetailList.wishlist = true
          this.addToWishlist(event,'add')
          return
        }
        if (this.productDetailList.wishlist == true) {
          this.productDetailList.wishlist = false
          this.addToWishlist(event,'delete')
          return
        }
      }
    }
    else {
      if (this.productDetailList.id == event) {
        this.productDetailList.wishlist = !this.productDetailList.wishlist
      }
      this.wishlistService.addItemToWishList(event)
      let wishList: any = [];
      wishList = this.wishlistService.getWishlist();
      wishList?.forEach((el: any) => {
        for (let i = 0; i < this.productDetailList?.length; i++) {
          if (el == this.productDetailList.id) {
            this.productDetailList.wishlist = true
          }
          else {
            this.productDetailList.wishlist = false
          }
        }
      })
    }
  }

  addToWishlist(event: any,type:any) {
    let data
    if(type == 'add'){
    data = {
      "product": [event],
      action_type: "add"
    }
  }else{
    data = {
      "action_type": "delete",
      "product_list": [event]
    }
  }
    this.sub.add(this.apiService.addToWishlist(data).subscribe({
      next: (res: any) => {
    if(type == 'add'){

        this.toastrService.success(res.data.msg)
        this.productDetailList.forEach((e: any) => {
          if (e.id == event) {
            e.wishlist = true
            return
          }
        })
      }else{
        this.toastrService.warning(res.data.msg)

      }
      },
      error: () => { },
      complete: () => { }
    }))
  }


  onFilterChange(event: any, source: any) {
    var type
    if (source == '') {
      type = event.target.value
    }
    else {
      type = event
    }
    if (type == 'Newest First') {
      this.productRatingList = this.productRatingList.sort((a: any, b: any) => {
        return <any>new Date(b.updated_date) - <any>new Date(a.updated_date);
      });
    }
    else if (type == 'Oldest First') {
      this.productRatingList = this.productRatingList.sort((a: any, b: any) => {
        return <any>new Date(a.updated_date) - <any>new Date(b.updated_date);
      });
    }
  }

  getRatingValue(value){
    if(this.productRatingList?.length && value >0){
      let rating = this.productRatingList?.length;
    let width = ((100/rating)*value)+'%';
    return width;
    }
    else{
      return 0;
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
